import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';

import {
  ProductSibling,
} from '../../types';

const MenuList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  margin: 9px 0 19px;
  padding: 12px 0 29px 39px;
  border: 1px solid ${COLOR.kurlyGray250};
  line-height: 20px;
`;

const MenuItem = styled.li`
  flex: 0 0 263px;
  overflow: hidden;
  padding: 16px 40px 0 0;
  &:nth-of-type(4n) {
    flex-basis: 180px;
    padding-right: 0;
  }
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MenuLink = styled.a<{ isCurrent: boolean; }>`
  letter-spacing: -1px;
  cursor: pointer;
  ${({ isCurrent }) => (isCurrent
    ? `font-weight: 500;color: ${COLOR.kurlyPurple};`
    : ''
  )}
  &:hover {
    font-weight: 500;
    color: ${COLOR.kurlyPurple};
  }
`;

interface Props {
  code: string;
  siblingCategorys: ProductSibling[];
  onMenuChange: (type: string)=> void;
}

export default function Menu({
  code,
  siblingCategorys,
  onMenuChange,
}: Props) {
  return (
    <MenuList>
      {siblingCategorys.map((it) => (
        <MenuItem key={it.code}>
          <MenuLink
            isCurrent={it.code === code}
            onClick={() => onMenuChange(it.code)}
          >
            {it.name}
          </MenuLink>
        </MenuItem>
      ))}
    </MenuList>
  );
}
